import { Typography, useMediaQuery, useTheme } from "@material-ui/core"
import { AddCircle } from "@material-ui/icons"
import { PropTypes } from "prop-types"
import React, { useContext } from "react"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import DarkButton from "~/components/Common/DarkButton"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import AppContext from "~/contexts/App"
import ClientContext from "~/contexts/Client"
import AddPathDialogGeneric from "~/dialogs/AddPathDialogGeneric"
import AddedPathCardGeneric from "~/dialogs/AddPathDialogGeneric/PathCard"
import Box from "../../Common/Box"
import useStyles from "./styles"

function DashboardLearningPath({ path, addedPaths, setAddedPaths, index }) {
  return (
    <Draggable draggableId={path.id.toString()} index={index}>
      {(provided) => {
        return (
          <AddedPathCardGeneric
            path={path}
            type="view"
            index={index}
            addedPaths={addedPaths}
            setAddedPaths={setAddedPaths}
            provided={provided}
          />
        )
      }}
    </Draggable>
  )
}

DashboardLearningPath.propTypes = {
  path: PropTypes.object,
  index: PropTypes.number,
  addedPaths: PropTypes.array,
  setAddedPaths: PropTypes.func,
}

function DashboardLearningPathList({ paths, setAddedPaths }) {
  return paths?.map((path, index) => (
    <DashboardLearningPath
      path={path}
      type="view"
      index={index}
      key={path.id}
      addedPaths={paths}
      setAddedPaths={setAddedPaths}
    />
  ))
}

DashboardLearningPathList.propTypes = {
  paths: PropTypes.array,
  setAddedPaths: PropTypes.func,
}

const DashboardPaths = ({ reorder }) => {
  const theme = useTheme()
  const classes = useStyles()
  const phoneView = useMediaQuery(theme.breakpoints.down("sm"))
  const { dashboardLearningPaths, setDashboardLearningPaths } =
    useContext(ClientContext)

  const { openDialog } = useContext(AppContext)

  function onDashboardLearningPathsDragEnd(result) {
    if (!result.destination) {
      return
    }

    if (result.destination.index === result.source.index) {
      return
    }

    const orderedDashboardLearningPaths = reorder(
      dashboardLearningPaths,
      result.source.index,
      result.destination.index,
    )

    setDashboardLearningPaths(orderedDashboardLearningPaths)
  }

  const addDashboardLearningPaths = async () => {
    const newLearningPaths = await openDialog(
      "addPathDialogGeneric",
      dashboardLearningPaths,
    )
    if (newLearningPaths !== null) {
      setDashboardLearningPaths(newLearningPaths)
    }
  }

  return (
    <>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        marginBottom="10px"
        width="100%"
        zIndex={10}
      >
        <Box display="flex" flexDirection="row" flexWrap="wrap">
          <Typography
            variant="h3"
            color="primary"
            style={{ fontWeight: "700", marginRight: "8px" }}
          >
            Learning Paths
          </Typography>
          <Typography
            variant="h3"
            color="primary"
            className={classes.orderText}
          >
            In order as they appear
          </Typography>
        </Box>
        <PermissionsWrapper permissionGroup="admin">
          <DarkButton
            onClick={addDashboardLearningPaths}
            startIcon={
              <AddCircle
                fontSize="small"
                classes={{ root: classes.addCircle }}
              />
            }
          >
            {phoneView ? "Add" : "Add Learning Path"}
          </DarkButton>
        </PermissionsWrapper>
      </Box>

      <Box paddingBottom="32px" position="relative">
        {dashboardLearningPaths?.length > 0 ? (
          <DragDropContext onDragEnd={onDashboardLearningPathsDragEnd}>
            <Droppable droppableId="path">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  <DashboardLearningPathList
                    paths={dashboardLearningPaths}
                    setAddedPaths={setDashboardLearningPaths}
                  />
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        ) : null}
      </Box>
      <AddPathDialogGeneric />
    </>
  )
}

DashboardPaths.propTypes = {
  reorder: PropTypes.func,
}

export default DashboardPaths
